import CallCenterUsers from "./CallCenterUsers";

const CallCenterUsersConfig = {
	settings: {},
	routes: [
		{
			path: '/apps/company-details/call-center/users',
			component: CallCenterUsers
		}
	]
};

export default CallCenterUsersConfig;
